module.exports = __webpack_public_path__ + "static/img/group1.ae8ada91.png";